


import React, { useState } from "react";
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEye, faGripLines, faLayerGroup, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Divider, Input } from 'antd';

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { t } from "../../../i18n";



const LayerSelector = (props) => {
    // const [colors, setColors] = useState(props.colors);

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(props.colors);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        props.setColors(items);

        let svgCopy = JSON.parse(JSON.stringify(props.svg));
        let index = props.layerSelected;

        // Remove the dragged item from the array at the source index
        const [removed] = svgCopy.children.splice(result.source.index, 1);

        // Insert the removed item at the destination index
        svgCopy.children.splice(result.destination.index, 0, removed);

        // Shift the remaining items over if necessary
        if (result.source.index > result.destination.index) {
            for (let i = result.source.index; i < result.destination.index; i++) {
                [svgCopy.children[i], svgCopy.children[i + 1]] = [svgCopy.children[i + 1], svgCopy.children[i]];
            }
        } else {
            for (let i = result.source.index; i > result.destination.index; i--) {
                [svgCopy.children[i], svgCopy.children[i - 1]] = [svgCopy.children[i - 1], svgCopy.children[i]];
            }
        }

        props.updateSvg(svgCopy);

        props.setLayerSelected("all");



    };

    const handleCopy = (color, index) => {

        if (index < 0 || index >= props.svg.children.length) return;

        // Create a deep copy of the SVG object and the layer to be copied
        const svgCopy = JSON.parse(JSON.stringify(props.svg));
        const layerCopy = JSON.parse(JSON.stringify(svgCopy.children[index]));

        // Insert the copied layer right after the original one
        svgCopy.children.splice(index + 1, 0, layerCopy);

        // Update the SVG object in the parent component
        props.updateSvg(svgCopy);

        // Update the colors array in the parent component
        const colorsCopy = Array.from(props.colors);
        colorsCopy.splice(index + 1, 0, props.colors[index]);
        props.setColors(colorsCopy);




    };

    const handleDelete = (color, index) => {
        if (index < 0 || index >= props.svg.children.length) return;
        // props.setLayerSelected("all");
        // Update the currently selected layer
        // props.setLayerSelected(1);
        console.log("ligma");


        const colorsCopy = Array.from(props.colors);
        colorsCopy.splice(index, 1);
        props.setColors(colorsCopy);

    


        // Create a deep copy of the SVG object
        const svgCopy = JSON.parse(JSON.stringify(props.svg));


        // Remove the layer at the specified index
        svgCopy.children.splice(index, 1);

        // Update the SVG object in the parent component
        props.updateSvg(svgCopy);

        console.log("nuts");

        props.setLayerSelected('all');




    };

    return (
        <IonGrid style={{ width: "100%", margin:"0px", padding:"0px" }}>

            <IonRow style={{ justifyContent: 'center', paddingTop: '13px', paddingBottom: '3px' }}>
                <div
                    onClick={() => {
                        props.setLayerSelected('all');
                    }}
                    style={{
                    paddingLeft: '10px',
                    }}
                >

                    {t("Layers Panel")}
                    <FontAwesomeIcon
                        icon={faLayerGroup}
                        style={{
                            color: props.layerSelected === 'all' ? '#007aff' : '#000',
                            fontSize: '14px',
                            paddingLeft: '20px',
                        }}
                    />
                </div>

            </IonRow>
            <Divider

            style={{ margin: '0px', marginTop: '10px'}} />
            <IonCol
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="color-palette">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                // style={{ minWidth: `${props.colors.length * 50}px` }}
                            >
                                {props.colors.map((color, index) => (
                                    <Draggable key={`color-${index}`} draggableId={`color-${index}`} index={index}>
                                        {(provided) => (
                                            <div
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                ref={provided.innerRef}

                                            >
                                                <IonRow
                                                    justify="center"
                                                    className="layer-row"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        paddingBottom: "10px",
                                                        paddingTop: "10px",
                                                    }}
                                                    onClick={() => {
                                                        props.setLayerSelected(index);
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faGripLines}
                                                        style={{  paddingRight: "20px" }}
                                                        onClick={(e) => {
                                                            // e.stopPropagation();
                                                    
                                                        }}
                                                    />
                                                    <div
                                                        onClick={() => {
                                                            props.setLayerSelected(index);
                                                        }}
                                                        style={{
                                                            padding: "10px",
                                                            // borderStyle: "solid",
                                                            // borderWidth: "2px",
                                                            // borderColor:
                                                            //     props.layerSelected === index || props.layerSelected === "all"
                                                            //         ? "#007aff"
                                                            //         : "#f0f0f0",
                                                            // borderRadius: "5px",
                                                            backgroundColor: color,
                                                            width: "30px",
                                                            height: "30px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            cursor: "pointer",
                                                        }}
                                                    ></div>
                                                    {/* <Input
                                                        placeholder="Color"
                                                        style={{ width: "calc(90% - 120px)" }}
                                                        value={color.substring(1, color.length)}
                                                    /> */}
                                                    <FontAwesomeIcon
                                                        icon={faCopy}
                                                        style={{
                                                            marginLeft: "10px",
                                                            fontSize: "14px",
                                                            cursor: "pointer",
                                                        }}
                                                        // color="#EBD9B9"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            // props.setIsProModalVisible(true);
                                                            handleCopy(color, index)
                                                        }}
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faTrash}
                                                        style={{
                                                            marginLeft: "10px",
                                                            fontSize: "14px",
                                                            cursor: "pointer",
                                                        }}
                                                        // color="#EBD9B9"
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // Add this line to prevent propagation
                                                            // props.setIsProModalVisible(true);
                                                            handleDelete(color, index);
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: "10px",
                                                            height: "10px",
                                                            backgroundColor:
                                                                props.layerSelected === index || props.layerSelected === "all"
                                                                    ? "#007aff"
                                                                    : "transparent",
                                                            marginLeft: "15px",
                                                        }}
                                                    ></div>
                                                </IonRow>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </IonCol>
        </IonGrid>
    );
};



export default LayerSelector;
